<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"

        viewBox="0 0 24 24"
        stroke="currentColor" fill="currentColor"
        stroke-width="2"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M5 13l4 4L19 7"
        />
    </svg>
</template>

<script>
export default {
    name: "Icon_Done",
};
</script>

